import { BROADCAST_SET_SELECTED_SCENE } from 'actions/Types';

export default scene => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_SELECTED_SCENE,
      payload: scene
    };
    dispatch(action);
  };
};
